export const PUBLIC_PROFILE_STATISTIC_ACTIONS = {
    PROFILE_VIEW: 'PROFILE_VIEW',
    CONTENT_VIEW: 'CONTENT_VIEW',
    TEMPLATE_CLONE: 'TEMPLATE_CLONE',
}
